import { useEffect } from "react";
import {
  INACTIVITY_CHECK_INTERVAL_MILLIS,
  resetInactivityTimeout,
} from "utils/inactivityLogoutUtils";

export default function useExtendUserActivity(optionalCondition = true) {
  useEffect(() => {
    if (!optionalCondition) {
      return;
    }

    resetInactivityTimeout();

    const interval = setInterval(() => {
      resetInactivityTimeout();
    }, INACTIVITY_CHECK_INTERVAL_MILLIS);
    return () => clearInterval(interval);
  }, [optionalCondition]);
}
